<div class="row align-items-center">
  <div class="col-sm-12 col-lg-8">

    <div class="d-flex align-items-center flexmob">

      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <!--<i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview-->
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex">
        <!--<div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="receipt-pound" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>-->
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Cash (Receipts & Payments)
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 ">
            {{AccountingPeriod}}
          </h5>
        </div>
      </div>


    </div>
  </div>
  <div class="col-sm-12 col-lg-4 text-right" *ngIf="ispreview">
    <!--<div class="d-flex flex-sm-row flex-col align-items-center justify-content-end gap-10 flex-wrap">-->
    <div class="d-flex justify-content-end">
      <div class="p-8" style="background-color: #fff; border-radius:10px;">
        <button mat-flat-button class="bg-none m-r-10" (click)="Preview(modal)" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="eye"></i-tabler>Preview
          </div>
        </button>
        <button mat-flat-button class="bg-none text-end" (click)="sendMailTemplate(emailtemplate)" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18" name="mail"></i-tabler> <!--Send Mail-->
          </div>
        </button>
      </div>
    </div>
    <!--<button mat-flat-button color="primary" class="text-end" (click)="sendMailTemplate(emailtemplate)">
      <div class="d-flex align-items-center">
        <i-tabler class="icon-18 m-r-10" name="mail"></i-tabler> Send Mail
      </div>
    </button>-->
    <!--<div class="d-flex align-items-center justify-content-end">
      <button mat-flat-button color="primary" class="bg-warning text-end" (click)="toggleAgeColumn()">
        <div class="d-flex text-black">
          <span class="f-s-12 text-black">{{ showAgeColumn ? 'Hide' : 'Show' }}</span>
        </div>
      </button>

    </div>-->
  </div>
</div>


<!--<div class="col-12">
  <mat-card class="m-t-24">
    <mat-card-content class="p-x-20 p-y-10">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <div class="m-l-10 d-flex">
            <div>
              <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
                <i-tabler name="receipt-pound" class="icon-28" style="line-height: 30px !important"></i-tabler>
              </button>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
                Summary
              </h4>
              <h5 class="f-s-14  text-black-25 m-t-5 ">
                Net Receipts/(Payments): £100.00
              </h5>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="row">
            <div class="col-lg-4">
              <mat-card class="m-t-20">
                <mat-card-content class="bg-white border-radius10 p-16">
                  <h5 class="f-s-14 f-w-600">Total Receipts: </h5>
                  <p class="text-success f-w-600 f-s-18">
                    £400.00
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-lg-4">
              <mat-card class="m-t-20">
                <mat-card-content class="bg-white border-radius10 p-16">
                  <h5 class="f-s-14 f-w-600">
                    Total Payments:
                  </h5>
                  <p class="text-danger brandtext f-w-600 f-s-18"> £300.00</p>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-lg-4">
              <mat-card class="m-t-20">
                <mat-card-content class="bg-white border-radius10 p-16">
                  <h5 class="f-s-14 f-w-600">
                    Cash Funds This Year End
                  </h5>
                  <p class="brandtext brandtext f-w-600 f-s-18"> £100.00</p>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
      </mat-card>
</div>-->
<!--Period Finalised & Ready to Submit-->
<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
              <h4>Period Finalised & Ready to Submit</h4>
              <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->




<div class="col-12 p-0">

  <mat-card class="m-t-24">
    <mat-card-content class="p-0">

      <!--with fundtracking-->
      <div class="table-responsive  shadow-lg" style="max-height: 624px; overflow-y: auto; border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);" *ngIf="isFundTracking">
        <table mat-table [dataSource]="transactions" class="w-100">
          <ng-container matColumnDef="account_Name">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">
              Section A Cash (Receipts & Payments)
            </th>
            <td mat-cell *matCellDef="let transaction">
              <div class="d-flex align-items-center gap-12">
                <span class="f-s-14 f-w-400 p-l-20">{{ transaction.account_Name }} </span>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef class="f-w-600 f-s-14">
              Total
            </td>
          </ng-container>
          <ng-container matColumnDef="Unrestrictedfunds">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Unrestricted Funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="0" type="text" [value]="transaction.unrestricted" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ getUnrestrictedfundsocst()}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Restricted income funds (£)">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Restricted Funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="0" type="text" [value]="transaction.restricted" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ restrictedfunds() }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Endowment funds (£)">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Endowment Funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="0" type="text" [value]="transaction.endowment" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>

              <!--{{ restrictedfunds() }}-->
            </td>
          </ng-container>
          <ng-container matColumnDef="Total funds (£)">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Total Funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">

              <!--{{ transaction.total_This_Year }}-->
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="0" type="text" class="f-w-400" [value]="transaction.total_This_Year" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef class="f-w-600">

              <!--{{ total()  }}-->
            </td>
          </ng-container>
          <ng-container matColumnDef="Prior year funds (£)">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-15 text-right">
              Last Year (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="0" type="text" [value]="transaction.total_Last_Year" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
            </td>
          </ng-container>
          <ng-container matColumnDef="expence-description">
            <td mat-cell *matCellDef="let row" colspan="7" class="f-w-600 f-s-14 expence-row text-initial-cust">
              {{row.headersName}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Total">
            <td mat-cell *matCellDef="let row" colspan="7" class="f-w-600 f-s-14 expence-row">
              {{row.headersName}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns2;sticky :true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns2; when: isDataRow;"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expence-description']; when: isHeaderRow" class=" f-s-20 heightrow headerdark" style="background: rgb(234 234 234 / 0.29)"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns2; when: isfooterrow" class="bg-light-primary f-s-18 f-w-600 heightrow totalvalue"></tr>
        </table>
      </div>

      <!--without fundtracking-->
      <div class="table-responsive  shadow-lg" style="height:1000px" *ngIf="!isFundTracking">
        <table mat-table [dataSource]="transactions" class="w-100">
          <ng-container matColumnDef="account_Name">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">
              Section A Cash (Receipts & Payments)
            </th>
            <td mat-cell *matCellDef="let transaction">
              <div class="d-flex align-items-center gap-12">
                <span class="f-s-14 f-w-400 p-l-20">{{ transaction.account_Name }} </span>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef class="f-w-600 f-s-14">
              Total
            </td>
          </ng-container>
          <ng-container matColumnDef="Total funds (£)">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Total Funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right w30">

              <!--{{ transaction.total_This_Year }}-->
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="0" type="text" class="f-s-14 f-w-400" style="color: #787878;" [value]="transaction.total_This_Year" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>

              <!--{{ total()  }}-->
            </td>
          </ng-container>
          <ng-container matColumnDef="Prior year funds (£)">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-15 text-right">
              Last Year (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right w30">
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="0" type="text" [value]="transaction.total_Last_Year" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
            </td>
          </ng-container>
          <ng-container matColumnDef="expence-description">
            <td mat-cell *matCellDef="let row" colspan="7" class="f-w-600 f-s-14 expence-row text-initial-cust">
              {{row.headersName}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Total">
            <td mat-cell *matCellDef="let row" colspan="7" class="f-w-600 f-s-14 expence-row">
              {{row.headersName}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="ColumnsWithoutFundTracking;sticky :true"></tr>
          <tr mat-row *matRowDef="let row; columns: ColumnsWithoutFundTracking; when: isDataRow;"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expence-description']; when: isHeaderRow" class=" f-s-20 heightrow headerdark" style="background: rgb(234 234 234 / 0.29)"></tr>
          <tr mat-row *matRowDef="let row; columns: ColumnsWithoutFundTracking; when: isfooterrow" class="bg-light-primary f-s-18 f-w-600 heightrow totalvalue"></tr>
        </table>
      </div>

      <div class="row p-16 m-t-16">
        <div class="col-sm-12 col-md-4 col-4">
          <button mat-flat-button color="primary" class="bg-warning text-end" (click)="Back()">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
            </div>
          </button>
        </div>
        <div class="col-sm-12 col-md-8 col-8" align="right">
          <!--<button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark hidemenutext"> Save as Draft</span>
            </div>
          </button>-->
          <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveReceiptsandPayments()" [disabled]="!UserRoleAccess?.m1Create">
            <div class="d-flex">
              <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext">Next</span>
            </div>
          </button>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>


<!--<div class="col-lg-12">
  <mat-card>
    <mat-card-content class="p-0">
      <div class="p-16 b-b-1">
        <div class="row justify-content-between align-items-center">
          <div class="m-l-10">
            <p class="text-black-50 f-s-14">
              4 notes selected • Last updated: 6/24/2025
            </p>
          </div>
          <div class="text-right">
            <button mat-flat-button class="bgwhite m-r-10">
              <div class="d-flex  m-l-5 m-r-14 border-radius-0 ">
                <i-tabler class="icon-18" name="device-floppy"></i-tabler><span class="f-s-14">Save R&P Data</span>
              </div>
            </button>
            <button mat-flat-button class="bg-error m-r-10">
              <div class="d-flex align-items-center border-radius-0 ">
                <span class="f-s-14">Reset R&P Data</span>
              </div>
            </button>
            <button mat-flat-button color="primary m-r-10">
              <div class="d-flex align-items-center">
                <i-tabler class="icon-18 m-r-10" name="send"></i-tabler> Submit for Review
              </div>
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>-->

<ng-template #emailtemplate>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-14 p-b-0">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Send Mail</span></b>
          <button class="btn-close-dialog" (click)="cenceltemplate()">
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;" [formGroup]="Receipts_Paymentsform">
        <div class="col-lg-12">
          <div class="p-y-16 b-t-1" style="overflow: hidden;">

            <div class="col-lg-12" style=" padding: 20px; border-radius: 10px;">
              <div class="row align-items-center m-b-8">
                <div class="col-md-10">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">From</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="40" formControlName="from" value="example@mail.com" [disabled]="true" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row align-items-center m-b-8">
                <div class="col-md-10">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">To</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="100" formControlName="to" value="example@mail.com" />
                      <mat-error *ngIf="Receipts_Paymentsform.get('to')?.hasError('required')">
                        Email is required
                      </mat-error>
                      <mat-error *ngIf="Receipts_Paymentsform.get('to')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="d-flex align-items-center mb-0">
                    <mat-checkbox class="example-margin" (change)="Receipts_PaymentsformmailtoCC()" formControlName="ccCheckbox"></mat-checkbox>
                    <label class="f-s-14 f-w-600 m-0 p-0">CC/BCC</label>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="ifCCorBCCReceipts_Payments">
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">CC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="cc" maxlength="100" />
                      <mat-error *ngIf="Receipts_Paymentsform.get('cc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">BCC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="bcc" maxlength="100" />
                      <mat-error *ngIf="Receipts_Paymentsform.get('bcc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">Subject</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="Welcome to Charity Accounts Software" formControlName="subject" />
                      <mat-error *ngIf="Receipts_Paymentsform.get('subject')?.hasError('required')">
                        Subject is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <mat-card-content class="m-t-14 p-x-0">
              <div class="local-editor NgxEditor__Wrapper" style="height: 300px;">
                <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor1" [placeholder]="'Type here...'" formControlName="Body"></ngx-editor>
              </div>
            </mat-card-content>

            <hr class="m-t-24" style="opacity:0.2" />
            <div class="row p-t-16 p-b-0">
              <div class="col-sm-12 col-md-12 text-right">
                <button mat-flat-button type="submit" color="primary" class="bg-success rounded-5 m-r-10" (click)="sendmail()" [disabled]="isBodyEmpty(Receipts_Paymentsform)">
                  <div class="d-flex">
                    <span class="f-s-14 text-dark"> Send </span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-white border-light b-1 text-end m-r-10" (click)="cenceltemplate()">
                  <div class="d-flex text-black">
                    <span class="f-s-12 text-black"> Cancel </span>
                  </div>
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<!--<div class="spinner-container" *ngIf="ShowSpinner">
  <mat-spinner></mat-spinner>
</div>-->

<ng-template #modal>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-20">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Cash (Receipts & Payments) Report</span></b>
          <button class="btn-close-dialog" mat-dialog-close>
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;">
        <div class="col-lg-12" style="height:750px;">
          <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

<!--<div class="spinner-container" *ngIf="ShowSpinner">
  <mat-spinner></mat-spinner>
</div>-->

<div class="spinner-container" *ngIf="ShowSpinner">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</div>
